import React, {useEffect} from 'react'
import Moment from 'react-moment'
import socialIconInstagram from '../../../Common/_assets/img/icon/iconsimple-ig.png'
import socialIconTwitter from '../../../Common/_assets/img/icon/iconsimple-x.png'
import socialIconFacebook from '../../../Common/_assets/img/icon/iconsimple-fb.png'

const SidebarMeta = ({titleName,
                    socialFB,
                    socialTW,
                    socialIG,
                    reviewQuote,
                    reviewCredit,
                    indeeProjectKey,
                    setActiveProjectKey,
                     isLoggedIn,
                     setDisplayPinModal,
                     setDisplayScreenerProjectList,
                    setActiveTitleName
                }) => {

    useEffect( () => {
      let subscribed = true;
      if (subscribed) {
        Moment.globalLocale = 'en-us'
      }
      return ()=>{subscribed=false}
    }, [])



  return (


        <div className={'w-100'}>

          {
              reviewQuote && reviewCredit ?

                  <div className="text-center pt-4 pb-4 "
                       style={{letterSpacing: '0rem', lineHeight: '1.35em', fontSize: '1.15rem'}}>
                      "{reviewQuote}"
                      <div className="text-small font-weight-bold">~ {reviewCredit}</div>
                  </div>

                  : ""
          }

          <div className="d-flex titlepage__button--container pb-3 justify-content-center align-items-center">
              <button onClick={()=>{
                  console.log('isloggedin',isLoggedIn, indeeProjectKey)
                  setActiveProjectKey(indeeProjectKey)
                  setActiveTitleName(titleName)
                  if (isLoggedIn) {
                      setDisplayScreenerProjectList(true)
                  } else {
                      setDisplayPinModal(true)
                  }
              }} className="button__box col-12 col-md-4 justify-content-center">Watch Now</button>
          </div>


          {(socialFB || socialIG || socialTW) ? (
              <div className="titlepage__social--container pb-3  justify-content-center align-items-center ">
                  <div className="w-100 d-flex justify-content-center align-items-center">

                      {(socialTW) ? (
                          <div className="p-2"><a href={socialTW} target="_blank" rel="noopener noreferrer"><img
                              className="social-icon mx-1" src={socialIconTwitter} alt="Netflix"/></a></div>
                      ) : ("")}

                      {(socialIG) ? (
                          <div className="p-2"><a href={socialIG} target="_blank" rel="noopener noreferrer"><img
                              className="social-icon mx-1" src={socialIconInstagram} alt="Netflix"/></a></div>
                      ) : ("")}

                      {(socialFB) ? (
                          <div className="p-2"><a href={socialFB} target="_blank" rel="noopener noreferrer"><img
                              className="mx-1 social-icon" src={socialIconFacebook} alt="Netflix"/></a></div>
                      ) : ("")}


                  </div>
              </div>
          ) : ("")}


        </div>

  )

}

export default SidebarMeta
